/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Fc_Wins_3Inputs */

const en_fc_vs_fc_wins_3 = /** @type {(inputs: Fc_Vs_Fc_Wins_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs on Linux, FreeBSD and in the browser, not just macOS and Windows.`)
};

/**
* | output |
* | --- |
* | "Runs on Linux, FreeBSD and in the browser, not just macOS and Windows." |
*
* @param {Fc_Vs_Fc_Wins_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_fc_wins_3 = /** @type {((inputs?: Fc_Vs_Fc_Wins_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Fc_Wins_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_fc_wins_3(inputs)
});
export { fc_vs_fc_wins_3 as "fc.vs.fc_wins.3" }